import { render } from "./EditTranslationTable.vue?vue&type=template&id=5f0f9ef8&scoped=true"
import script from "./EditTranslationTable.vue?vue&type=script&lang=js"
export * from "./EditTranslationTable.vue?vue&type=script&lang=js"

import "./edit-translation-table.scss?vue&type=style&index=0&id=5f0f9ef8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0f9ef8"]])

export default __exports__